import { useCallback } from 'react';
import { useEffect, useRef, useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { useIsMounted } from './useIsMounted';
const usePromise = (initialPromise, meta)=>{
    if (initialPromise && typeof initialPromise !== 'function') {
        throw new Error('initialPromise must be a function.');
    }
    const [m, setMeta] = useState(meta);
    const [promise, setPromise] = useState(()=>{
        return initialPromise ? initialPromise() : null;
    });
    const [isLoading, setIsLoading] = useState(!!promise);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const mounted = useIsMounted();
    const lastPromise = useRef(null);
    useEffect(()=>{
        lastPromise.current = promise;
        setIsLoading(!!promise);
        setResult(null);
        setError(null);
        if (promise) {
            promise.then((res)=>{
                if (mounted.current && promise === lastPromise.current) {
                    unstable_batchedUpdates(()=>{
                        setResult(()=>res);
                        setIsLoading(false);
                    });
                }
            }).catch((err)=>{
                if (mounted.current && promise === lastPromise.current) {
                    unstable_batchedUpdates(()=>{
                        setError(err);
                        setIsLoading(false);
                    });
                }
            });
        }
    }, [
        promise,
        mounted
    ]);
    const exec = useCallback((promiseCreator, metaObj)=>{
        setPromise(promiseCreator);
        setMeta(metaObj);
    }, []);
    return {
        isLoading: isLoading,
        result: result,
        error: error,
        exec: exec,
        meta: m
    };
};
export default usePromise;
